import { FormHelperTextClassKey, StyleRules } from "@material-ui/core";
import { WarningColors } from "style/Colors";

export const MuiFormHelperText: Partial<StyleRules<FormHelperTextClassKey, {}>> = {
  root: {
    color: WarningColors.base,
    fontWeight: "bold",
  },
};
